export function isAmzLoginPage(content: any) {
  if (typeof content === "object") {
    return false;
  }
  const result =
    (content &&
      content.indexOf('<title dir="ltr">Amazon Sign In</title>') !== -1) ||
    (content &&
      content.indexOf('<title dir="ltr">Amazon Anmelden</title>') !== -1) ||
    (content &&
      content.indexOf('<title dir="ltr">Iniciar sesiÃ³n en Amazon</title>') !==
        -1) ||
    (content &&
      content.indexOf('<title dir="ltr">Connexion Amazon</title>') !== -1) ||
    (content &&
      content.indexOf('<title dir="ltr">Amazon Accedi</title>') !== -1) ||
    (content && /ap_password/.exec(content));
  return result;
}
